import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";

// Home stays eager (it's the LCP landing page); everything else is code-split
// so the initial bundle downloaded on first paint stays small.
const Blogs = lazy(() => import("@/pages/Blogs"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Products = lazy(() => import("@/pages/Products"));
const Reviews = lazy(() => import("@/pages/Reviews"));
const Coupons = lazy(() => import("@/pages/Coupons"));
const PumpingTips = lazy(() => import("@/pages/PumpingTips"));
const Giveaway = lazy(() => import("@/pages/Giveaway"));
const Contact = lazy(() => import("@/pages/Contact"));
const Login = lazy(() => import("@/pages/Login"));
const Admin = lazy(() => import("@/pages/Admin"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/best-breast-pumps" element={<Products />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route path="/pumping-tips" element={<PumpingTips />} />
            <Route path="/giveaway" element={<Giveaway />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
